import portrait from './index.vue'
portrait.install = Vue => Vue.component(portrait.name, portrait)
export default portrait
